<template>
  <div>
    <div class="white-section mb-2">
      <b-form @submit.prevent class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group
                :label="$t('medicalSpecialties.medicalSpecialtiesTitle')"
                label-for="medicalSpecialties-title"
                :invalid-feedback="
            invalidFeedbackTitle
              ? $t(`validation.${invalidFeedbackTitle}`, {
                  field: $t('medicalSpecialties.medicalSpecialtiesTitle'),
                })
              : ''
          "

            >
              <b-form-input autofocus
                            id="medicalSpecialties-title"
                            :state="$v.medicalSpecialtyToEdit.title.$dirty ? !$v.medicalSpecialtyToEdit.title.$invalid : null"
                            v-model="medicalSpecialtyToEdit.title"
                            v-on:keyup.enter="onEnter"

              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('general.status')" label-for="medicalSpecialties-status">
              <b-form-select
                  text-field="text"
                  value-field="value"
                  v-model="medicalSpecialtyToEdit.status"
                  :options="statuses"
                  id="medicalSpecialties-status"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <div class="white-section">
      <b-col md="12" class="text-right">
        <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            class="col-12"
            @click="editMedicalSpecialty"
        >
          {{ $t("general.submit") }}
        </b-button>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback, BBreadcrumb,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  mounted() {
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  data() {
    return {
      items: [
        {
          text: this.$t('medicalSpecialties.medicalSpecialties'),
          to: '/medical-specialties/'
        },
        {
          text: this.$t('medicalSpecialties.editMedicalSpecialties'),
          active: true
        }
      ]
    }
  },
  validations() {
    return {
      medicalSpecialtyToEdit: {
          title: {
            required,
          },
      }
    };
  },
  computed: {
    invalidFeedbackTitle: {
      set(error) {},
      get() {
        let  error = "";
        if (!this.$v.medicalSpecialtyToEdit.title.$dirty) return error;
        if (!this.$v.medicalSpecialtyToEdit.title.required) error = "required";
        return error;
      },
    },
    ...mapGetters({
      statuses: "general/statuses",
    }),
    medicalSpecialtyToEdit: {
      set(medicalSpecialtyToEdit) {
        this.$store.commit("medicalSpecialties/SET_MEDICAL_SPECIALTY_TO_EDIT", medicalSpecialtyToEdit);
      },
      get() {
        return this.$store.getters["medicalSpecialties/medicalSpecialtyToEdit"];
      },
    },
    
  },
  methods: {
    onEnter(){
      this.editMedicalSpecialty()
    },
    editMedicalSpecialty() {
        const payload = {
          title: this.medicalSpecialtyToEdit.title,
          status: this.medicalSpecialtyToEdit.status,
        };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.commit('SET_IS_LOADING', true)
        this.$store
            .dispatch("medicalSpecialties/updateMedicalSpecialty", {
              id: this.medicalSpecialtyToEdit._id,
              payload: payload,
            })
            .then(() => {
              this.$store.commit('SET_IS_LOADING', false)
              this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                title: this.$t('toastification.success'),
                variant: 'success',
                solid: true,
              });
              this.$router.push({name: "manageMedicalSpecialties"});
            })

            .catch((error) => {
              let msg = '';
              switch (error.response.status){
                case 422:
                  msg = this.$t('toastification.duplicatedData');
                  break;

                case 404:
                  msg = this.$t('toastification.notFound');
                  break;
              }
              this.$bvToast.toast(msg, {
                title: this.$t('toastification.error'),
                variant: 'danger',
                solid: true,
              });
              this.$store.commit('SET_IS_LOADING', false)
            });

      }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
    },
  },
  created() {
      let params = this.$route.params;
      this.$store.dispatch('medicalSpecialties/getMedicalSpecialtyToEdit', params.id).then(res=>{
        this.pushBreadcrumb({text: 'editMedicalSpecialties', to:{name:'editMedicalSpecialties' }, translate:true});
        this.pushBreadcrumb( {text: res.title , translate:false});
        this.setCurrentBreadcrumb([{text: 'editMedicalSpecialties', to:{name:'editMedicalSpecialties' }, translate:true},{text: res.title , translate:false} ]);
      })
  }
};
</script>